export const REGEX_PATTERNS = {
    //eslint-disable-next-line
    userName: /^[A-Za-z0-9_\-!#$%&'*+\/=?^{}|~`][A-Za-z0-9._\-!#$%&'*+\/=?^{}|~`]*([@\\\/])([A-Za-z0-9][A-Za-z0-9\\-]*[A-Za-z0-9]\.?)*([A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/
};
export const SupportedLanguage = ['ru', 'en', 'it'];
